import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import About from "./components/About";
import Home from "./components/Home";
import Layout from "./layouts/Layout";
import Links from "./components/Links";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import { BLOG_URL } from "./constants";

function BlogRedirect() {
  useEffect(() => {
    window.location.replace(BLOG_URL);
  }, []);

  return null;
}

export default function Router() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/links" element={<Links />} />
        <Route path="/blog" element={<BlogRedirect />} />
        <Route path="/blog/*" element={<BlogRedirect />} />
      </Route>
    </Routes>
  );
}
